import React from 'react'
import styles from './statistic-modal.module.scss'
import moment from 'moment'

export default function SendStatisticStepOne({ onFoundYes, onFoundNo, vacancyData }) {
  const formatSalary = () => {
    if (!vacancyData) return ''
    const { salary, salary_currency_symbol, salary_rate } = vacancyData
    return `${salary_currency_symbol}${salary?.toLocaleString()}/${salary_rate}`
  }
  const dateFormat = JSON.parse(localStorage.getItem('settings'))?.date_format || 'MMM YYYY'

  const renderVacancyDetails = () => {
    if (!vacancyData) return null

    const {
      vacancy_type,
      rank_name,
      vessel_name,
      vessel_type_name,
      country_name,
      join_date_range,
      join_date,
    } = vacancyData

    if (vacancy_type === 'land') {
      return (
        <p className={styles['statisticStepOne__vacancyInfo']}>
          <span className={styles['statisticStepOne__infoLabel']}>Land Vacancy</span>
          {' | '}
          <strong> Rank:</strong> {rank_name} |<strong> Salary:</strong> {formatSalary()} |<strong> Country:</strong>{' '}
          {country_name || 'N/A'} |<strong> Join Date:</strong>{' '}
          {join_date_range ? (
            <time dateTime={vacancyData.join_date} className={styles['statisticStep__company-date']}>
              {vacancyData.join_date_range.toUpperCase()} {moment(vacancyData.join_date).format('MMM YYYY') || '–'}
            </time>
          ) : (
            <time dateTime={vacancyData.join_date} className={styles['statisticStep__company-date']}>
              {moment(vacancyData.join_date).format(dateFormat) || '–'}
            </time>
          )}
        </p>
      )
    }

    // Sea vacancy
    return (
      <p className={styles['statisticStepOne__vacancyInfo']}>
        <strong>Rank:</strong> {rank_name} |<strong> Salary:</strong> {formatSalary()} |
        {vessel_name ? (
          <>
            <strong> Vessel:</strong> {vessel_name} |<strong> Type:</strong> {vessel_type_name} |
          </>
        ) : (
          <>
            <strong> Vessel Type:</strong> {vessel_type_name} |
          </>
        )}
        <strong> Join Date:</strong>{' '}
        {join_date_range ? (
          <time dateTime={vacancyData.join_date} className={styles['statisticStep__company-date']}>
            {vacancyData.join_date_range.toUpperCase()} {moment(vacancyData.join_date).format('MMM YYYY') || '–'}
          </time>
        ) : (
          <time dateTime={vacancyData.join_date} className={styles['statisticStep__company-date']}>
            {moment(vacancyData.join_date).format(dateFormat) || '–'}
          </time>
        )}
      </p>
    )
  }

  return (
    <>
      {vacancyData && vacancyData.rank_name && vacancyData.rank_name.length > 0 ? (
        <div className={styles['statisticStepOne']}>
          {vacancyData && vacancyData.vacancy_close_reason === 'expired' ? (
            <b>Did you manage to find the crew?</b>
          ) : (
            <b>Did you find the crew?</b>
          )}

          {vacancyData && vacancyData.vacancy_close_reason === 'expired' ? (
            <p>
              Hello! The vacancy{' '}
              <span className={styles['statisticStepOne__vacancyName']}>{vacancyData?.rank_name || ''}</span> has
              expired. Were you able to find the crew?
            </p>
          ) : (
            <p>
              Hello! You have just closed this vacancy{' '}
              <span className={styles['statisticStepOne__vacancyName']}>{vacancyData?.rank_name || ''}</span> <br />
              Does this mean you successfully found the crew? Let us know to improve our service.
            </p>
          )}
          {renderVacancyDetails()}
          <div className={styles['statisticStep__buttons']}>
            <button onClick={onFoundYes} className={styles['statisticStep__button']}>
              Yes, we found the crew
            </button>
            <button onClick={onFoundNo} className={styles['statisticStep__button']}>
              No, we didn’t find them
            </button>
          </div>
          <span>Your feedback helps us improve the platform and make hiring easier for you!</span>
        </div>
      ) : (
        <div className={styles['statisticStepOne']}>
          <div className={styles['statisticStepOne__skeleton-title']} />
          <div className={styles['statisticStepOne__skeleton-text']} />
          <div className={styles['statisticStepOne__skeleton-info']} />
          <div className={styles['statisticStepOne__skeleton-buttons']}>
            <div className={styles['statisticStepOne__skeleton-button']} />
            <div className={styles['statisticStepOne__skeleton-button']} />
          </div>
        </div>
      )}
    </>
  )
}
